export default "__VITE_ASSET__DsQA5$1W__"